import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/landingpage.css";
import heroImg from "../img/herokep.jpg";

/* ================= FEATURE CARD ================= */
function FeatureCard({ icon, title, details, buttonTitle, to }) {

  return (
    <div className="lp-feature"
    >

      <div className="lp-feature-icon">
        {icon}
      </div>

      <div className="lp-feature-title">
        {title}
      </div>

      <div className="lp-feature-text">
        {details}
      </div>

      <div className="lp-feature-button">
        <button className="lp-card-btn">
          <Link className="nav-link" to={to} >{buttonTitle}</Link>

        </button>
      </div>


    </div>
  );
}

// GYIK KERDESEK
function FaqItem({ question, answer }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`lp-faq-item ${open ? "open" : ""}`}>
      <button
        className="lp-faq-question"
        onClick={() => setOpen(!open)}
      >
        <span>{question}</span>
        <span className="lp-faq-icon">{open ? "−" : "+"}</span>
      </button>

      {open && (
        <div className="lp-faq-answer">
          {answer}
        </div>
      )}
    </div>
  );
}

export default function LandingPage() {
  // const [mostLikedPosts, setMostLikedPosts] = useState(null);

  //TITLE, META TAG BEÁLLITÁS
  useEffect(() => {
    document.title = "Tippmix statisztikák és tippek | FociFanatik";

    const meta = document.querySelector("meta[name='description']");
    if (meta) {
      meta.setAttribute(
        "description",
        "Sportfogadás statisztikák, elemzések és tippek egy helyen. Nézd meg statisztikáinkat, készíts saját stratégiákat, jegyzetelj és hozz jobb döntéseket a FociFanatikon."
      );
    }
  }, []);

  const mostLikedPosts = [
    {
      "id": 5,
      "text": "Ez egy poszt szövegasdasdasdasdasdasdasdasdasdasdasdasdasd",
      "username": "Zsolt",
      "like_count": 12,
      "comment_count": 3
    },
    {
      "id": 2,
      "text": "Másik poszt",
      "username": "Anna",
      "like_count": 8,
      "comment_count": 1
    }
  ]

  // A KÉT LEGLIKEOLTABB HETI POSZT LEKÉRÉSE
  // useEffect(() => {
  //     fetch("https://focifanatik.hu/api/landingPage/mostLikedPosts.php")
  //         .then((response) => response.json())
  //         .then((data) => {
  //             if (data.success) {
  //                 setMostLikedPosts(data);
  //             }
  //         })
  //         .catch((err) => console.error("Hiba a lekéréskor:", err));
  // }, []);


  return (
    <div className="lp">

      {/* ================= HERO ================= */}
      <section className="lp-hero">
        <img src={heroImg} alt="TippBázis" className="lp-hero-bg" />

        <div className="lp-hero-content">
          {/* <span className="lp-badge">📊 ADATALAPÚ SPORT ELEMZÉS</span> */}

          <h1>
            Adatalapú <span>foci statisztikák</span><br />
            és <span>elemzések</span> egy helyen.
          </h1>

          <p>
            Kövesd nyomon a mérkőzések statisztikáit, elemezd a csapatok formáját,
            használd a közösségi szavazásokat és építs saját stratégiákat,
            hogy tudatosabb döntéseket hozhass.
          </p>

          <div className="lp-actions">
            <a href="/regisztracio" className="lp-btn primary">
              Ingyenes regisztráció
            </a>
            <a href="/meccselemzo" className="lp-btn secondary">
              Mai statisztikák
            </a>
          </div>
        </div>
      </section>

      {/* ================= FEATURES ================= */}
      <section className="lp-features">
        <h2>Mit nyújt a TippBázis?</h2>
        <p className="lp-sub">
        </p>

        <div className="lp-feature-wrapper">
          <div className="lp-feature-list">
            <div className="lp-feature-card">
              <FeatureCard
                icon={<i class="bi bi-bar-chart-line"></i>}
                title="Meccs statisztikák"
                details="Részletes meccs- és csapatstatisztikák segítségével elemezheted a csapatok aktuális formáját, gólátlagait, hazai–idegenbeli teljesítményét és egymás elleni eredményeit. A trendek és adatok segítenek abban, hogy ne megérzésből, hanem adatalapúan hozd meg a döntéseidet."
                buttonTitle={"Megnézem"}
                to={'/meccselemzo'}
              />
            </div>

            <div className="lp-feature-card">
              <FeatureCard
                icon={<i class="bi bi-envelope-paper"></i>}
                title="Tippelés"
                details="Minden nap több mérkőzésre adhatsz le szavazatot, és azonnal láthatod, hogyan gondolkodik a közösség az adott meccsről. A szavazások nem fogadási tanácsok, hanem hasznos visszajelzések, amelyek segítenek felmérni az aktuális véleményeket és irányokat."
                buttonTitle={"Megnézem"}
                to={'/szavazas'}
              />
            </div>

            <div className="lp-feature-card">
              <FeatureCard
                icon={<i class="bi bi-bullseye"></i>}
                title="Stratégia rendszer"
                details="Hozd létre saját fogadási stratégiáidat, és kövesd nyomon azok működését hosszú távon. A rendszer segít elemezni a találati arányt, az eredményességet és a teljesítmény-mutatókat, így folyamatosan finomíthatod a módszereidet."
                buttonTitle={"Bejelentkezés"}
                to={'/bejelentkezes'}
              />
            </div>

            <div className="lp-feature-card">
              <FeatureCard
                icon={<i class="bi bi-card-text"></i>}
                title="Saját jegyzetek"
                details="Készíts saját jegyzeteket csapatonként, hogy minden fontos megfigyelésed egy helyen legyen. Így nem veszik el az értékes információ, és mindig vissza tudsz térni a korábbi gondolataidhoz döntés előtt."
                buttonTitle={"Bejelentkezés"}
                to={'/bejelentkezes'}
              />
            </div>

          </div>
        </div>
      </section>

      {/* ================= FORUM MODERN ================= */}
      <section className="lp-forum-modern">
        <div className="lp-forum-box">

          <div className="lp-forum-left">
            <span className="lp-forum-badge">🔥 KÖZÖSSÉG</span>

            <h2>
              Tippmegosztó <span>fórum</span><br />
              ahol minden <span>meccs életre kel</span>
            </h2>

            <p>
              Oszd meg tippjeidet, vitasd meg a mérkőzéseket és nézd meg,
              hogyan gondolkodik a közösség. Valós vélemények, valós gondolatok,
              egy helyen.
            </p>

            <div className="lp-forum-actions">
              <a href="/forum" className="lp-btn primary big glow">
                Fórum megnyitása
              </a>
            </div>
          </div>

          <div className="lp-forum-right">
            <div className="lp-forum-card">
              <div className="lp-forum-user"><i class="bi bi-person"></i> {mostLikedPosts[0].username}</div>
              <div className="lp-forum-post">
                {mostLikedPosts[0].text.length > 54 ? mostLikedPosts[0].text.slice(0, 54) + "..." : mostLikedPosts[0].text}
              </div>
              <div className="lp-forum-stats"><i class="bi bi-hand-thumbs-up"></i> {mostLikedPosts[0].like_count} • <i class="bi bi-chat"></i> {mostLikedPosts[0].comment_count}</div>
            </div>

            <div className="lp-forum-card second">
              <div className="lp-forum-user"><i class="bi bi-person"></i> {mostLikedPosts[1].username}</div>
              <div className="lp-forum-post">
                {mostLikedPosts[1].text.length > 54 ? mostLikedPosts[1].text.slice(0, 54) + "..." : mostLikedPosts[1].text}
              </div>
              <div className="lp-forum-stats"><i class="bi bi-hand-thumbs-up"></i> {mostLikedPosts[1].like_count} • <i class="bi bi-chat"></i> {mostLikedPosts[1].comment_count}</div>
            </div>
          </div>

        </div>
      </section>

      {/* ================= FAQ ================= */}
      <section className="lp-faq">
        <h2>Gyakori kérdések</h2>

        <div className="lp-faq-list">

          <FaqItem
            question="Ingyenesen használható a FociFanatik?"
            answer="Igen, a FociFanatik alap funkciói teljesen ingyenesen használhatók. Regisztráció után hozzáférsz a meccsstatisztikákhoz, elemzésekhez, szavazásokhoz és saját jegyzetekhez is."
          />

          <FaqItem
            question="Milyen statisztikákat találok a FociFanatik oldalon?"
            answer="Részletes meccs- és csapatstatisztikákat, formaadatokat, gólátlagokat, egymás elleni eredményeket és teljesítmény-trendeket találsz, amelyek segítenek megalapozott döntéseket hozni."
          />

          <FaqItem
            question="Miben segít a FociFanatik a sportfogadásban?"
            answer="Az oldal célja, hogy átlátható statisztikákkal, elemzésekkel és közösségi visszajelzésekkel támogassa a tudatosabb döntéshozatalt. Nem ad fogadási tanácsot, hanem adatokat és nézőpontokat."
          />

          <FaqItem
            question="Hogyan működik a szavazás a mérkőzéseknél?"
            answer="Minden mérkőzésnél láthatod, hogy a közösség milyen kimenetelre szavazott. Ez segít képet kapni az aktuális véleményekről és trendekről."
          />

          <FaqItem
            question="Készíthetek saját stratégiákat az oldalon?"
            answer="Igen, a stratégia rendszerrel saját fogadási elveket és stratégiákat hozhatsz létre, amelyeket később nyomon követhetsz és elemezhetsz."
          />

          <FaqItem
            question="Mire használhatók a saját jegyzetek?"
            answer="A jegyzet funkcióval csapatonként rögzítheted a fontos megfigyeléseidet, így minden információ egy helyen marad."
          />

          <FaqItem
            question="Milyen gyakran frissülnek a statisztikák?"
            answer="A statisztikák folyamatosan frissülnek az aktuális mérkőzések és eredmények alapján, különösen a hétvégi fordulók során."
          />

          <FaqItem
            question="Kell regisztrálni a FociFanatik használatához?"
            answer="Az oldal egy része regisztráció nélkül is elérhető, azonban a teljes funkcionalitás – például szavazás, jegyzetelés és stratégiák – regisztrációhoz kötött."
          />

          <FaqItem
            question="Kapok értesítést az új statisztikákról és elemzésekről?"
            answer="Igen, ha engedélyezed az értesítéseket, emailben tájékoztatunk az új statisztikákról, elemzésekről és kiemelt mérkőzésekről."
          />

          <FaqItem
            question="Kinek ajánlott a FociFanatik?"
            answer="A FociFanatik ideális választás mindenkinek, aki érdeklődik a labdarúgás, a statisztikák és az adatalapú sportelemzés iránt – legyen kezdő vagy haladó felhasználó."
          />

        </div>
      </section>


      {/* ================= CTA ================= */}
      <section className="lp-cta-wrap">
        <div className="lp-cta-box pro">

          <h2>
            Kezdj el <span>okosabban</span> és <span>tudatosabban</span> dönteni
          </h2>

          <p className="lp-cta-lead">
            Minden statisztika, elemzés és eszköz egy helyen a tudatosabb
            sportelemzéshez.
          </p>


          <div className="lp-cta-actions">
            <a href="/regisztracio" className="lp-btn primary big glow">
              Ingyenes regisztráció
            </a>

          </div>

        </div>
      </section>

    </div>
  );
}
